import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';

import { TextAreaField, DefaultButton } from 'common/components';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { FormattedMessage } from 'react-intl';
import { boCloseUserChallenge } from '../../_redux';
import { staticStyles } from './style';

const CloseChallengeForm = ({ challengeId, handleSubmit, submitting, onRequestClose, closeUserChallenge }) => {
  const submit = handleSubmit(values => closeUserChallenge({ challengeId, reason: values.reason }));

  return (
    <form className="CloseChallengeForm" onSubmit={submit}>
      <FormattedMessage id="closeChallengeWarning">{txt => <p>{txt}</p>}</FormattedMessage>
      <Field
        component={TextAreaField}
        name="reason"
        textId="closeChallengeReason"
        rows="2"
        cols="50"
        disabled={submitting}
      />

      <div className="CloseChallengeForm__buttons">
        <DefaultButton
          textId="closeChallenge"
          type="submit"
          butColor="error"
          loading={submitting}
          disabled={submitting}
        />
        <DefaultButton textId="justCancel" type="button" onClick={onRequestClose} />
      </div>

      <style jsx global>
        {staticStyles}
      </style>
    </form>
  );
};

CloseChallengeForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  closeUserChallenge: PropTypes.func.isRequired,
  challengeId: PropTypes.string.isRequired,
};

export default compose(
  connect(null, { closeUserChallenge: data => boCloseUserChallenge.request(data) }),
  reduxForm({
    form: 'CloseChallengeForm',
    onSubmitSuccess: (result, dispatch, props) => {
      props.onRequestClose();
    },
  })
)(CloseChallengeForm);
